import { RouteModule } from '#/horizon/components/RouteModule';
import { useI18n } from '#/i18n/hooks/useI18n';
import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { orgDashboardApiIsomorphicFetchInternship } from '#/modules/orgDashboard/api/listing/orgDashboardApiFetchInternship';
import { orgDashboardEditInternshipRoute } from '#/modules/orgDashboard/routing/orgDashboard.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { OrgDashboardEditInternshipPageLoadable } from './OrgDashboardEditInternshipPageLoadable';

export const handle = {
  fallbackUrlByLocaleToCurrent: true,
  darkBackground: true,
  showDesktopSearch: true,
} satisfies LayoutHandleProps;

export async function loader({
  request,
  context,
  params: { orgId, internshipId },
}: HorizonAppRouteLoaderArgs<typeof orgDashboardEditInternshipRoute>) {
  const [internship] = await Promise.all([
    orgDashboardApiIsomorphicFetchInternship({ request, context })(
      orgId,
      internshipId,
    ),
    OrgDashboardEditInternshipPageLoadable.load(),
  ]);

  return { internship };
}

export default function OrgDashboardEditInternshipHorizonRoute({
  loaderData: { internship },
}: HorizonAppRouteComponentProps<typeof loader>) {
  const { i18n } = useI18n();

  return (
    <RouteModule title={i18n('Edit Internship')}>
      <OrgDashboardEditInternshipPageLoadable internship={internship} />
    </RouteModule>
  );
}
